import { render, staticRenderFns } from "./recharge_delivery_table.vue?vue&type=template&id=4affe35c&scoped=true&"
import script from "./recharge_delivery_table.vue?vue&type=script&lang=ts&"
export * from "./recharge_delivery_table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4affe35c",
  null
  
)

export default component.exports